import React, { useState } from 'react';
import { updateAreaTarea } from '../services/tareasService';
import { getAreas } from '../services/Admin/areaService';
import './styles/components.css';

const CambiarAreaButton = ({ tareaId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [areas, setAreas] = useState([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleOpenModal = async () => {
    setIsModalOpen(true);
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const data = await getAreas();
      setAreas(data);
    } catch (e) {
      setError('Error al cargar áreas');
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelected('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selected) {
      setError('Seleccione un área');
      return;
    }
    setLoading(true);
    const resp = await updateAreaTarea(tareaId, selected);
    if (resp.success) {
      setSuccess('Área actualizada');
      setTimeout(() => {
        handleCloseModal();
      }, 1000);
    } else {
      setError(resp.message);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="area-btn" onClick={handleOpenModal} style={{ fontSize: '14px' }}>
        Cambiar área
      </button>
      {isModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container" style={{ minWidth: 350, maxWidth: 400 }}>
            <div className="modal-permisos-header">
              <h2 className="modal-permisos-title">Cambiar Área</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-permisos-body">
                {loading && <p>Cargando...</p>}
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: '8px' }}>{success}</div>}
                {!loading && areas.length > 0 && (
                  <div className="form-group">
                    <label htmlFor="area">Área:</label>
                    <select
                      id="area"
                      value={selected}
                      onChange={e => setSelected(e.target.value)}
                      style={{ width: '100%', padding: '8px', marginTop: '8px', borderRadius: '4px', border: '1px solid #e0e0e0' }}
                    >
                      <option value="">Seleccione un área</option>
                      {areas.map(area => (
                        <option key={area.id_area} value={area.id_area}>{area.nombre}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="modal-permisos-actions">
                <button type="button" onClick={handleCloseModal} className="modal-permisos-btn cancelar">
                  Cancelar
                </button>
                <button type="submit" className="area-btn" disabled={loading}>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CambiarAreaButton; 